import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { AuthProvider } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { LanguageProvider } from './contexts/LanguageContext'
import App from './App.tsx'
import PWAPrompts from './components/PWAPrompts'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
        <LanguageProvider>
        <AuthProvider>
          <NotificationProvider>
            <App />
            <PWAPrompts />
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: 'var(--sl-card-bg)',
                  color: 'var(--sl-text)',
                  border: '1px solid var(--sl-surface-border)',
                  borderRadius: '14px',
                  fontSize: '14px',
                  fontWeight: '600',
                  backdropFilter: 'blur(20px)',
                },
                className: 'toast',
              }}
              closeButton
            />
          </NotificationProvider>
        </AuthProvider>
        </LanguageProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
)

